import type { FaireProductEntity } from "../../entity_types/product";

export const p_eyiekigm: FaireProductEntity = {
  token: "p_eyiekigm",
  type: "product",
  name: "Lovebirds | Anniversary Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3e46a28e8eb05f8f1c8eb0fd39117afbd2fe4c9753274d93c348ddb870491007.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/338fa370b33aab693bfa96fdb9ca3979562d9bc86c272f5076dce69f0178cf70.webp",
    "https://cdn.faire.com/fastly/1d3529a117e15e8cc27f2a99c887cbbf9a49be86cafd60bf45ea8164faf18bad.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d7207bd9f3355125c44182b9f5990b62e5bf9c7c9e0b190b8c4774b21e0f0390/1528361174.png",
  ],
  priceDollars: 3,
  description:
    "Those chubby bird bodies! The saturated colors! We want this art on a card for every occasion, but for now, send to your parents or friends or anyone whose wedding you remember.... it will be SO much fun to receive!\n \nEach E. Frances card begins as an original watercolor painting, is then printed in brilliant color on luxe, heavyweight paper and finally kissed with copper foil.\n \nMade in the USA.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:13.911Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
